import { Card } from '@/shared/ui'
import { DebugPanelProfileSettings } from '@/shared/lib/debug-panel/DebugPanelProfileSettings'

/**
 * Ferramental de staff, fora do conteúdo do participante.
 *
 * Antes vivia num `Card` entre os dados pessoais e o networking, no scroll de
 * todo mundo — o próprio `DebugPanelProfileSettings` retornava `null` para
 * não-elegíveis, mas a montagem seguia no meio da tela. Agora a seção só existe
 * para quem é elegível, e a rota tem guarda própria.
 */
export const DevelopmentPanel = () => (
  <Card>
    <Card.Body className="p-4 sm:p-5">
      <DebugPanelProfileSettings />
    </Card.Body>
  </Card>
)
